import { createApp } from 'vue';
import axios from 'axios';
import mitt from 'mitt';
import { Emit } from '../directives/emit.js';
import { ScrollTo } from '../directives/scrollto.js';
import { scrollTo } from '../mixins/ScrollTo.js';
import {i18n} from '../i18n';
import store from '../store';

/**
 * Inicjalizuje aplikację Vue z podanym komponentem.
 * @param {object} AppComponent - Komponent Vue do załadowania
 */
export function initVueApp(AppComponent) {
  const vueApp = createApp(AppComponent);

  // Globalne właściwości
  vueApp.config.globalProperties.$axios = axios;
  vueApp.config.globalProperties.$axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

  let token = document.head.querySelector('meta[name="wp-nonce"]');

  if (token) { // X-CSRF-TOKEN
    vueApp.config.globalProperties.$axios.defaults.headers.common['X-WP-Nonce'] = token.content;
  } else {
    console.error('CSRF token not found');
  }

  vueApp.config.globalProperties.$emitter = mitt();

  // Mixin i dyrektywy
  vueApp.mixin(scrollTo);
  vueApp.directive('emit', Emit);
  vueApp.directive('scrollto', ScrollTo);

  // Use i18n and store
  vueApp.use(i18n);
  vueApp.use(store);

  // Montowanie aplikacji do DOM
  vueApp.mount('#app');
}
